export default [
	{ cat: 2, underweight: 18.5, normal: 4.4, overweight: 4.5, obesity: 22.6 },
	{ cat: 1, underweight: 18.5, normal: 6.4, overweight: 5, obesity: 20.1 },
];
